import React, { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';

const RegionContext = createContext();

export const useRegion = () => {
  const context = useContext(RegionContext);
  if (!context) {
    throw new Error('useRegion must be used within a RegionProvider');
  }
  return context;
};

export const RegionProvider = ({ children }) => {
  const location = useLocation();
  
  // Determine current region from URL - Default to Ireland (ie)
  const getRegion = () => {
    if (location.pathname.startsWith('/pt')) {
      return 'pt'; // Keep for backwards compatibility but will redirect
    }
    // Default to Ireland for all routes
    return 'ie';
  };

  const region = getRegion();
  
  // Get the base path for the current region - Always use /ie
  const basePath = '/ie';
  
  // Helper function to create region-aware links - Always use /ie
  const getLink = (path) => {
    if (path === '/') return '/ie';
    return `/ie${path}`;
  };

  // Region-specific data
  const regionData = {
    pt: {
      name: 'Portugal',
      area: 'Algarve - Faro',
      phone: '+351 912289942',
      whatsapp: '351912289942',
      email: 'support@sancurservices.com',
      instagram: '@sancurservices',
      currency: '€',
      defaultLanguage: 'pt',
      description: {
        pt: 'Serviços residenciais e comerciais de confiança no Algarve',
        en: 'Trusted residential and commercial services in Algarve',
        es: 'Servicios residenciales y comerciales de confianza en Algarve'
      }
    },
    ie: {
      name: 'Ireland',
      area: 'Dublin',
      phone: '+353 89 950 2499',
      whatsapp: '353899502499',
      email: 'suporte@sancurservices.com',
      instagram: '@sancurservices',
      currency: '€',
      defaultLanguage: 'en',
      description: {
        pt: 'Serviços profissionais de limpeza doméstica em Dublin',
        en: 'Professional house cleaning services in Dublin',
        es: 'Servicios profesionales de limpieza del hogar en Dublín'
      }
    }
  };

  const currentRegionData = regionData[region];

  return (
    <RegionContext.Provider value={{ 
      region, 
      basePath, 
      getLink,
      regionData: currentRegionData,
      isPortugal: region === 'pt',
      isIreland: region === 'ie'
    }}>
      {children}
    </RegionContext.Provider>
  );
};

export default RegionContext;
